"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6212],{

/***/ 56212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ platform_interactive_experience_homepage_first_fold_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/consts.js
var INTERACTION_MODE_CHANGE_ANIMATION_DURATION = 0.5;
var INTERACTION_HOVER_ANIMATION_DURATION = 0.5;
var RIPPLE_DEFAULT_ANIMATION_DURATION = 4;
var GLOW_IMG_SRC = "https://dapulse-res.cloudinary.com/image/upload/v1707905637/Generator_featured%20images/Homepage%20-%202024/michael-testing/Ellipse_5790.png";
var SYSTEM_BACKGROUND_IMG_SRC = "https://dapulse-res.cloudinary.com/image/upload/v1707905613/Generator_featured%20images/Homepage%20-%202024/michael-testing/system_layout.png";

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/platform-iteraction/platform-interaction-component.scss.js




var ICON_MODE_SIZE = "100px";
var StyledPlatformInteractionComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16yxdbp0"
})("position:absolute;top:", function(param) {
    var position = param.position;
    var _position_top;
    return (_position_top = position === null || position === void 0 ? void 0 : position.top) !== null && _position_top !== void 0 ? _position_top : "0";
}, ";left:", function(param) {
    var position = param.position;
    var _position_left;
    return (_position_left = position === null || position === void 0 ? void 0 : position.left) !== null && _position_left !== void 0 ? _position_left : "0";
}, ";.interaction-wrapper{background-color:#232446;border-radius:4px;border:1px solid #505050;width:", function(param) {
    var dimentions = param.dimentions;
    return dimentions === null || dimentions === void 0 ? void 0 : dimentions.width;
}, ";transition:all 0.5s;.image-mode-container{position:relative;pointer-events:none;user-select:none;opacity:1;z-index:1;transition:opacity ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s;img{transition:width ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s;}}.ripple-container{opacity:1;transition:opacity ", INTERACTION_HOVER_ANIMATION_DURATION, "s;position:absolute;top:0;left:0;width:100%;height:100%;.ripple-border{position:absolute;top:0;left:0;bottom:0;right:0;margin:auto;border:1px solid ", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";border-radius:4px;height:95%;width:95%;z-index:0;pointer-events:none;user-select:none;}.ripple-one{animation:ripple_animation\n          ", function(param) {
    var rippleEffectAnimationDuration = param.rippleEffectAnimationDuration;
    return rippleEffectAnimationDuration > 0 ? rippleEffectAnimationDuration : RIPPLE_DEFAULT_ANIMATION_DURATION;
}, "s\n          linear 0s infinite;}.ripple-two{animation:ripple_animation\n          ", function(param) {
    var rippleEffectAnimationDuration = param.rippleEffectAnimationDuration;
    return rippleEffectAnimationDuration > 0 ? rippleEffectAnimationDuration : RIPPLE_DEFAULT_ANIMATION_DURATION;
}, "s\n          linear 1s infinite;}}}.interaction-wrapper:hover{scale:1.1;transition:scale ", INTERACTION_HOVER_ANIMATION_DURATION, "s;.ripple-container{opacity:0;transition:opacity ", INTERACTION_HOVER_ANIMATION_DURATION, "s;}}@keyframes ripple_animation{0%{transform:scale(1.1);opacity:0;}5%{transform:scale(1.1);opacity:1;}35%{opacity:0.4;}50%{transform:scale(1.4);opacity:0;}100%{transform:scale(1.4);opacity:0;}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/platform-iteraction/platform-interaction-component.js



function PlatformInteractionComponent(props) {
    var image = props.image, position = props.position, rippleEffectAnimationDuration = props.rippleEffectAnimationDuration, onInteractionClick = props.onInteractionClick, className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlatformInteractionComponent, {
        position: position,
        rippleEffectAnimationDuration: rippleEffectAnimationDuration,
        dimentions: {
            width: image === null || image === void 0 ? void 0 : image.width
        },
        className: "platform-interaction-component ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "interaction-wrapper",
            onClick: onInteractionClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-mode-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                        image: {
                            src: image === null || image === void 0 ? void 0 : image.src
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ripple-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ripple-border ripple-one"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ripple-border ripple-two"
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/nav-menu/nav-menu-component.scss.js


var StyledNavMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebq4ghd0"
})("margin-bottom:28px;.interaction-tags-container{display:flex;gap:16px;font-size:0.875rem;overflow-x:auto;-webkit-mask-image:linear-gradient(90deg,rgba(0,0,0,1) 93%,rgba(0,0,0,0) 100%);mask-image:linear-gradient(90deg,rgba(0,0,0,1) 93%,rgba(0,0,0,0) 100%);.interaction-tag{cursor:pointer;border:1px solid #ffffff30;border-radius:50px;color:#b6b6bb;background-color:#0b0b1c;padding:8px 18px;transition:all 0.3s;text-wrap:nowrap;:hover:not(.active){background-color:#282852;}&.active{color:white;border-color:#b6b6bb;}}::-webkit-scrollbar{display:none;}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){.interaction-tags-container{gap:8px;font-size:0.75rem;}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/nav-menu/nav-menu-component.js



var NavMenuComponent = function(props) {
    var className = props.className, interactions = props.interactions, currentInteraction = props.currentInteraction, onInteractionClick = props.onInteractionClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavMenuComponent, {
        className: "nav-menu-component ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "interaction-tags-container",
            children: interactions === null || interactions === void 0 ? void 0 : interactions.map(function(interaction, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("interaction-tag", {
                        active: currentInteraction === index
                    }),
                    onClick: function() {
                        return onInteractionClick(index);
                    },
                    children: interaction.label
                });
            })
        })
    });
};
/* harmony default export */ var nav_menu_component = (NavMenuComponent);

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/platform-interactive-experience-homepage-first-fold-desktop-component/platform-interactive-experience-homepage-first-fold-desktop-component.scss.js




var StyledPlatformInteractiveExperienceHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1b89yv20"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;height:", function(param) {
    var segmentHeight = param.segmentHeight;
    return segmentHeight !== null && segmentHeight !== void 0 ? segmentHeight : "40vw";
}, ";", function(param) {
    var segmentMaxHeight = param.segmentMaxHeight;
    return segmentMaxHeight ? "max-height: ".concat(segmentMaxHeight, ";") : "";
}, "  display:flex;justify-content:center;align-items:center;position:relative;.info-section-wrapper{position:absolute;top:0;left:0;width:26vw;max-width:550px;z-index:", z_index/* LAYER_ONE */.KW, ";.info-section{padding-top:8px;padding-left:32px;display:flex;flex-direction:column;gap:30px;opacity:0;transition:opacity 1s;.back-botton{cursor:pointer;font-size:0.875rem;position:relative;margin-left:10px;.back-arrow{position:absolute;left:-10px;transition:transform 0.5s;}&:hover{.back-arrow{transform:translateX(-5px);transition:transform 0.5s;}}}.info-content-wrapper{position:relative;.info-content{position:absolute;width:100%;top:0;left:-100%;display:flex;flex-direction:column;gap:30px;opacity:0;transition:all 1s;h2{font-size:1.5rem;line-height:2rem;font-weight:600;transition:all 1s;}.paragraph-body{font-size:1rem;line-height:1.5;font-weight:300;transition:all 1s;}&.active{left:0;opacity:1;transition:all 1s;}}}&.active{opacity:1;transition:opacity 1s;}}}.interactive-section-wrapper{position:absolute;top:0;width:100vw;transition:left 0.5s ease-in-out;display:flex;justify-content:center;.interactive-section{position:relative;width:", function(param) {
    var backgroundSize = param.backgroundSize;
    return backgroundSize !== null && backgroundSize !== void 0 ? backgroundSize : "60vw";
}, ";max-width:1100px;left:", function(param) {
    var isInteractionActive = param.isInteractionActive;
    return isInteractionActive ? "min(22vw,550px)" : "0";
}, ";transition:left 0.5s ease-in-out;.glow{position:absolute;width:", function(param) {
    var glowWidth = param.glowWidth;
    return glowWidth !== null && glowWidth !== void 0 ? glowWidth : "30vw";
}, ";top:", function(param) {
    var glowPositionTop = param.glowPositionTop;
    return glowPositionTop !== null && glowPositionTop !== void 0 ? glowPositionTop : "0";
}, ";left:", function(param) {
    var glowPositionLeft = param.glowPositionLeft;
    return glowPositionLeft !== null && glowPositionLeft !== void 0 ? glowPositionLeft : "0";
}, ";z-index:", z_index/* ZERO */.xE, ";}.system-layout-wrapper{position:relative;width:100%;z-index:", z_index/* LAYER_ONE */.KW, ";.interactions-nav-menu{opacity:0;transition:opacity ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s;&.active{opacity:1;transition:opacity ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s;}}.system-layout{position:relative;.system-action-wrapper{opacity:0;position:absolute;top:0;left:0;width:100%;transition:opacity ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s;&.show{animation:appear ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s forwards;}&.hide{animation:dissapear ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s forwards;}}}}.platform-interaction{position:absolute;z-index:", z_index/* LAYER_TWO */.wc, ";opacity:1;transition:opacity 1s,top ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s,left ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, 's;.interaction-wrapper{cursor:pointer;}// when the interactions are hidden we have to give them display none because we interacte with elements behind them.\n        // we have the "show" class so we can add back the display block but make them appear with animation\n\n        &.show{animation:appear ', INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s forwards;}&.hide{animation:dissapear ", INTERACTION_MODE_CHANGE_ANIMATION_DURATION, "s forwards;.interaction-wrapper{cursor:default;}}}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){.info-section-wrapper{width:32vw;}}@keyframes change-position-value{0%{position:absolute;}100%{position:static;}}@keyframes appear{0%{display:block;opacity:0;}100%{opacity:1;}}@keyframes dissapear{0%{opacity:1;}100%{opacity:0;display:none;}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/platform-interactive-experience-homepage-first-fold-desktop-component/platform-interactive-experience-homepage-first-fold-desktop-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var PlatformInteractiveExperienceHomepageFirstFoldDesktopComponent = function(props) {
    var interactions = props.interactions, rippleEffectAnimationDuration = props.rippleEffectAnimationDuration, glowImage = props.glowImage, backgroundImage = props.backgroundImage, backgroundSize = props.backgroundSize, segmentHeight = props.segmentHeight, segmentMaxHeight = props.segmentMaxHeight;
    var ref = (0,react.useState)(-1), currentInteraction = ref[0], setCurrentInteraction = ref[1];
    var infoSectionRef = (0,react.useRef)(null);
    var onBackButtonClick = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PLATFORM_INTERACTIVE_EXPERIENCE_BACK_BUTTON_CLICKED);
        setCurrentInteraction(-1);
    };
    var onInteractionClick = function(index) {
        var _infoSectionRef_current_getBoundingClientRect, _infoSectionRef_current, _interactions_index;
        var y = (infoSectionRef === null || infoSectionRef === void 0 ? void 0 : (_infoSectionRef_current = infoSectionRef.current) === null || _infoSectionRef_current === void 0 ? void 0 : (_infoSectionRef_current_getBoundingClientRect = _infoSectionRef_current.getBoundingClientRect()) === null || _infoSectionRef_current_getBoundingClientRect === void 0 ? void 0 : _infoSectionRef_current_getBoundingClientRect.top) + window.scrollY - 100;
        if (y) {
            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        }
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PLATFORM_INTERACTIVE_EXPERIENCE_INTERACTION_CLICKED, {
            kind: (_interactions_index = interactions[index]) === null || _interactions_index === void 0 ? void 0 : _interactions_index.label
        });
        setCurrentInteraction(index);
    };
    var onInteractionTagClick = function(index) {
        var _interactions_index;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PLATFORM_INTERACTIVE_EXPERIENCE_INTERACTION_TAG_CLICKED, {
            kind: (_interactions_index = interactions[index]) === null || _interactions_index === void 0 ? void 0 : _interactions_index.label
        });
        setCurrentInteraction(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPlatformInteractiveExperienceHomepageFirstFoldComponent, {
        className: "platform-interactive-experience-homepage-first-fold-component",
        isInteractionActive: currentInteraction >= 0,
        segmentHeight: segmentHeight,
        segmentMaxHeight: segmentMaxHeight,
        glowWidth: glowImage === null || glowImage === void 0 ? void 0 : glowImage.width,
        glowPositionTop: glowImage === null || glowImage === void 0 ? void 0 : glowImage.positionTop,
        glowPositionLeft: glowImage === null || glowImage === void 0 ? void 0 : glowImage.positionLeft,
        backgroundSize: backgroundSize,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "info-section-wrapper",
                ref: infoSectionRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("info-section", {
                        active: currentInteraction >= 0
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "back-botton",
                            onClick: onBackButtonClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "back-arrow",
                                    children: "<"
                                }),
                                " ",
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "info-content-wrapper",
                            children: interactions === null || interactions === void 0 ? void 0 : interactions.map(function(interaction, index) {
                                var _interaction_content;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("info-content", {
                                        active: currentInteraction === index
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread_props(_object_spread({}, interaction === null || interaction === void 0 ? void 0 : interaction.content), {
                                        buttonConfig: _object_spread_props(_object_spread({}, interaction === null || interaction === void 0 ? void 0 : (_interaction_content = interaction.content) === null || _interaction_content === void 0 ? void 0 : _interaction_content.buttonConfig), {
                                            extraData: {
                                                platformTab: interaction === null || interaction === void 0 ? void 0 : interaction.label
                                            }
                                        })
                                    }))
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "interactive-section-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "interactive-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "glow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                                image: {
                                    src: glowImage === null || glowImage === void 0 ? void 0 : glowImage.src
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "system-layout-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_menu_component, {
                                    className: classnames_default()("interactions-nav-menu", {
                                        active: currentInteraction >= 0
                                    }),
                                    interactions: interactions,
                                    currentInteraction: currentInteraction,
                                    onInteractionClick: onInteractionTagClick
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "system-layout",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "system-background",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                                                image: {
                                                    src: backgroundImage || SYSTEM_BACKGROUND_IMG_SRC
                                                }
                                            })
                                        }),
                                        interactions === null || interactions === void 0 ? void 0 : interactions.map(function(interaction, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({
                                                className: classnames_default()("system-action-wrapper", {
                                                    show: currentInteraction === index,
                                                    hide: currentInteraction !== index
                                                })
                                            }, interaction.actionAsset));
                                        })
                                    ]
                                })
                            ]
                        }),
                        interactions === null || interactions === void 0 ? void 0 : interactions.map(function(interaction, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformInteractionComponent, {
                                className: classnames_default()("platform-interaction", {
                                    show: currentInteraction < 0,
                                    hide: currentInteraction >= 0
                                }),
                                isRippleEffectOn: true,
                                image: interaction.image,
                                icon: interaction.icon,
                                label: interaction.label,
                                position: interaction.position,
                                rippleEffectAnimationDuration: rippleEffectAnimationDuration,
                                onInteractionClick: function() {
                                    return onInteractionClick(index);
                                }
                            }, index);
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var platform_interactive_experience_homepage_first_fold_desktop_component = (PlatformInteractiveExperienceHomepageFirstFoldDesktopComponent);

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-mobile-component/building-blocks-tabs-mobile-component.js + 1 modules
var building_blocks_tabs_mobile_component = __webpack_require__(22617);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/platform-interactive-experience-homepage-first-fold-mobile-component/platform-interactive-experience-homepage-first-fold-mobile-component.scss.js



var StyledPlatformInteractiveExperienceHomepageFirstFoldMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15ybru30"
})("&.platform-interactive-experience-homepage-first-fold-mobile-component{.slick-slider.focus .slick-list .slick-track .slick-slide .carousel-item{opacity:1;}.side-by-side-text-and-asset .image-wrapper{padding:0 5px 0 !important;}.mobile-tabs-component .mobile-tabs-navigation{padding-bottom:20px;.tab-nav-button{color:", colors/* default */.Z[color_consts.SILVER_MIST_COLOR_NAME], ";background-color:black;border:", colors/* default */.Z[color_consts.CHARCOAL_GRAY_COLOR_NAME], " 1px solid;&.selected{color:white;border-color:", colors/* default */.Z[color_consts.SILVER_MIST_COLOR_NAME], ";}}}}");

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/util/interaction_tab_convertor.js
/// /// converts an interaction json to a building-blocks-tabs tab json
function interaction_tab_convertor_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function interaction_tab_convertor_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            interaction_tab_convertor_define_property(target, key, source[key]);
        });
    }
    return target;
}
function interaction_tab_convertor_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function interaction_tab_convertor_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        interaction_tab_convertor_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function convertInteractionToTab(interaction) {
    var _interaction_content;
    return {
        tabLabel: interaction === null || interaction === void 0 ? void 0 : interaction.label,
        tabIcon: interaction === null || interaction === void 0 ? void 0 : interaction.icon,
        textAndAsset: interaction_tab_convertor_object_spread_props(interaction_tab_convertor_object_spread({}, DEFAULT_TEXT_AND_ASSET_PARAMS), {
            fullParagraph: (_interaction_content = interaction === null || interaction === void 0 ? void 0 : interaction.content) !== null && _interaction_content !== void 0 ? _interaction_content : EMPTY_CONTENT_OBJECT,
            asset: (interaction === null || interaction === void 0 ? void 0 : interaction.actionAsset) || {}
        })
    };
}
var DEFAULT_TEXT_AND_ASSET_PARAMS = {
    contentClassName: "",
    swapTextAndAssetPosition: false,
    leftSizeWidth: null,
    rightSizeWidth: null,
    background: {},
    assetQuality: "",
    withDynamicParagraphTitle: false,
    withDynamicParagraphSubtitle: false,
    paddingTop: "",
    paddingBottom: "",
    titleSize: "",
    textSize: ""
};
var EMPTY_CONTENT_OBJECT = {
    topic: {},
    title: "",
    body: "",
    textAlign: "",
    mobileTextAlign: "",
    titleColor: "",
    buttonConfig: {}
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/components/platform-interactive-experience-homepage-first-fold-mobile-component/platform-interactive-experience-homepage-first-fold-mobile-component.js
function platform_interactive_experience_homepage_first_fold_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function platform_interactive_experience_homepage_first_fold_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            platform_interactive_experience_homepage_first_fold_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function platform_interactive_experience_homepage_first_fold_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function platform_interactive_experience_homepage_first_fold_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        platform_interactive_experience_homepage_first_fold_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var PlatformInteractiveExperienceHomepageFirstFoldMobileComponent = function(props) {
    var interactions = props.interactions;
    var tabs = (0,react.useMemo)(function() {
        var _interactions_map;
        return (_interactions_map = interactions === null || interactions === void 0 ? void 0 : interactions.map(function(interaction) {
            return convertInteractionToTab(interaction);
        })) !== null && _interactions_map !== void 0 ? _interactions_map : [];
    }, [
        interactions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlatformInteractiveExperienceHomepageFirstFoldMobileComponent, {
        className: "platform-interactive-experience-homepage-first-fold-mobile-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(building_blocks_tabs_mobile_component/* default */.Z, platform_interactive_experience_homepage_first_fold_mobile_component_object_spread_props(platform_interactive_experience_homepage_first_fold_mobile_component_object_spread({}, props), {
            tabs: tabs,
            displayContentTitle: true
        }))
    });
};
/* harmony default export */ var platform_interactive_experience_homepage_first_fold_mobile_component = (PlatformInteractiveExperienceHomepageFirstFoldMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/platform-interactive-experience-homepage-first-fold-component.js



var PlatformInteractiveExperienceHomepageFirstFoldComponent = (0,responsive_hoc_component/* default */.Z)(platform_interactive_experience_homepage_first_fold_desktop_component, platform_interactive_experience_homepage_first_fold_mobile_component);
/* harmony default export */ var platform_interactive_experience_homepage_first_fold_component = (PlatformInteractiveExperienceHomepageFirstFoldComponent);


/***/ })

}]);